import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { BASE_URL1 } from "../utils/apiURL";
import { STATUS } from "../utils/status";

const initialState = {
    products: [],
    productsStatus: STATUS.IDLE,
    productSingle: [],
    productSingleStatus: STATUS.IDLE
}

const productSlice = createSlice({
    name: "product",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
        .addCase(fetchAsyncProducts.pending, (state, action) => {
            state.productsStatus = STATUS.LOADING;
        })

        .addCase(fetchAsyncProducts.fulfilled, (state, action) => {
            state.products = action.payload;
            state.productsStatus = STATUS.SUCCEEDED;
        })
        
        .addCase(fetchAsyncProducts.rejected, (state, action) => {
            state.productsStatus = STATUS.FAILED
        })
    }
});

// for getting the products list with limited numbers
export const fetchAsyncProducts = createAsyncThunk('products/fetch', async() => {
    const response = await fetch(`${BASE_URL1}all/app/product`);
    const data = await response.json();
    return data.products;
});

// getting the single product data also
export const fetchAsyncProductSingle = createAsyncThunk(
  "products/fetchSingle",
  async (productId, { getState }) => {
    const { products } = getState().product; // Récupérer tous les produits depuis le state
    const product = products.find((p) => p.id === productId); // Filtrer le produit par id
    return product || null; // Si produit trouvé, retourner, sinon retourner null
  }
);

export const getProductById = (state, productId) => {
  return state.product.products.find(
    (product) => product.id === parseInt(productId)
  );
};


export const getAllProducts = (state) => state.product.products;
export const getAllProductsStatus = (state) => state.product.productsStatus;
export const getProductSingle = (state) => state.product.productSingle;
export const getSingleProductStatus = (state) => state.product.productSingleStatus;
export default productSlice.reducer;